<template>
  <div style="display: none;">
    <ReportContainer
      :titulo="'CONTRATOS – RELATÓRIO DE ACOMPANHAMENTO'"
      :subtitulo="'Departamento Jurídico'"
      :revisao="'Revisão 4'"
      :data="'25/11/2024'"
      :content_botton_1="assinaturas"
      :content_botton_2="observacao"
      @close="$emit('close')">
      <div>
        <table style="width: 100%; border: 2px solid black; border-collapse: collapse; font-size: 12px;">
          <!-- ITEM 1 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>1. DADOS </strong><br><br>
              <strong>Data de Abertura do Relatório: </strong>{{ new Date(dados[0].DATA_ABERTURA).toLocaleDateString() }}<br>
              <strong>Tipo de Contrato: </strong>{{ dados[0].TIPO_CONTRATO }}<br>
              <strong>Departamento Responsável pela Formalização do Contrato: </strong>{{ dados[0].DEPTO_RESP_CONTRATO }}<br>
              <strong>Empresa do Grupo Zopone: </strong>{{ dados[0].EMPRESA_GRUPO }}<br>
              <strong>Nome Solicitante: </strong>{{ dados[0].SOLICITANTE }}<br>
              <strong>* Responsável pelo Fechamento do Contrato: </strong>{{ dados[0].RESPONSAVEL_FECHAMENTO_CONTRATO }}<br>
              <strong>CNPJ: </strong>{{ dados[0].CNPJ }}<br>
              <strong>* Razão Social: </strong>{{ dados[0].RAZAO_SOCIAL }}<br>
              <strong>Endereço: </strong>{{ dados[0].ENDERECO }}<br>
              <strong>Cidade: </strong>{{ dados[0].CIDADE }}<br>
              <strong>Contato (Email/Telefone): </strong>{{ dados[0].CONTATO }}<br>
            </td>
          </tr>
          <!-- ITEM 2 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>2. DEPARTAMENTO JURÍDICO - GRUPO ZOPONE</strong><br><br>
              <strong>Data Recebimento do Contrato: </strong>{{ new Date(dados[0].RECEBIMENTO_CONTRATO).toLocaleDateString() }}<br>
              <strong>Data Prevista para Assinatura do Contrato: </strong>{{ new Date(dados[0].DATA_PREV_ASS_CONTRATO).toLocaleDateString() }}<br>
              <strong>Data Assinatura do Contrato: </strong>{{ new Date(dados[0].DATA_ASS_CONTRATO).toLocaleDateString() }}<br>
              <strong>Coordenador Jurídico: </strong>{{ dados[0].COORDENADOR_JURIDICO }}<br>
              <strong>Adv Interno Responsável: </strong>{{ dados[0].ADV_INTERNO_RESPONSAVEL }}<br>
              <strong>Adv Externo Responsavel: </strong>{{ dados[0].ADV_EXTERNO_RESPONSAVEL }}<br>
            </td>
          </tr>
          <!-- ITEM 3 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>3. CONTRAPARTE</strong><br><br>
              <strong>Responsavel: </strong>{{ dados[0].CONTRAPARTE_RESPONSAVEL }}<br>
              <strong>Contato: </strong>{{ dados[0].CONTRAPARTE_CONTATO_RESP }}<br>
              <strong>Responsável Técnico pelo Fechamento do Contrato: </strong>{{ dados[0].CONTRAPARTE_RESP_TECNICO }}<br>
              <strong>Contato: </strong>{{ dados[0].CONTRAPARTE_CONTATO_RESP_TECNICO }}<br>
              <strong>Responsável Comercial pelo Fechamento do Contrato: </strong>{{ dados[0].CONTRAPARTE_RESP_COMERCIAL }}<br>
              <strong>Contato: </strong>{{ dados[0].CONTRAPARTE_CONTATO_RESP_COMERCIAL }}<br>
              <strong>Responsável Jurídico pelo Fechamento do Contrato: </strong>{{ dados[0].CONTRAPARTE_RESP_JURIDICO }}<br>
              <strong>Contato: </strong>{{ dados[0].CONTRAPARTE_CONTATO_RESP_JURIDICO }}<br>
              <strong>Proprietário do Imovel: </strong>{{ dados[0].CONTRAPARTE_PROPRIETARIO_IMOVEL }}<br>
              <strong>Responsavel Negociacao: </strong>{{ dados[0].CONTRAPARTE_RESP_NEGOCIACAO }}<br>
              <strong>Contato: </strong>{{ dados[0].CONTRAPARTE_CONTATO_RESP_NEGOCIACAO }}<br>
              <strong>Advogado: </strong>{{ dados[0].CONTRAPARTE_ADVOGADO }}<br>
              <strong>Contato: </strong>{{ dados[0].CONTRAPARTE_CONTATO_ADVOGADO }}<br>
              <strong>Nº Externo do Contrato: </strong>{{ dados[0].CONTRAPARTE_NR_EXTERNO_CONTRATO }}<br>
              <strong>Revisão Nº: </strong>{{ dados[0].CONTRAPARTE_REVISAO_NR }}<br>
            </td>
          </tr>
          <!-- ITEM 4 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>4. ESCOPO/OBJETO DO CONTRATO (Responsável: {{ dados[0].ESCOPO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].ESCOPO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].ESCOPO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 5 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>5. ALTERAÇÃO ESCOPO (Responsável: {{ dados[0].ALTERACAO_ESCOPO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].ALTERACAO_ESCOPO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].ALTERACAO_ESCOPO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 6 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>6. VALOR DO CONTRATO E RESPECTIVA CONFERÊNCIA DO DOCUMENTO PERTINENTE (Responsável: {{ dados[0].VALOR_CONTRATO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].VALOR_CONTRATO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].VALOR_CONTRATO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 7 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>7. FORMA DE PAGAMENTO E PRAZO DE PAGAMENTO (Responsável: {{ dados[0].FORMA_PAGAMENTO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].FORMA_PAGAMENTO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].FORMA_PAGAMENTO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 8 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>8. REAJUSTE, PRAZO, ÍNDICE E DATA BASE (Responsável: {{ dados[0].REAJUSTE_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].REAJUSTE_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].REAJUSTE_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
        <!-- ITEM 9 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>9. REEQUILIBIO ECONÔMICO FINANCEIRO (Responsável: {{ dados[0].REEQUILIBRIO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].REEQUILIBRIO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].REEQUILIBRIO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 10 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>10. DOCUMENTOS E CERTIDÕES (Responsável: {{ dados[0].DOCUMENTOS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].DOCUMENTOS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].DOCUMENTOS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 11-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>11. LICENÇAS FEDERAIS, ESTADUAISE MUNICIPAIS (Responsável: {{ dados[0].LICENCAS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].LICENCAS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].LICENCAS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 12-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>12. PRAZOS CONTRATUAIS (Responsável: {{ dados[0].PRAZOS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].PRAZOS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].PRAZOS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 13-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>13. OBRIGAÇÕES DA CONTRATADA (Responsável: {{ dados[0].OBRIGACOES_CONTRATADA_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].OBRIGACOES_CONTRATADA_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].OBRIGACOES_CONTRATADA_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 14-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>14. OBRIGAÇÕES DO CONTRATANTE (Responsável: {{ dados[0].OBRIGACOES_CONTRATANTE_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].OBRIGACOES_CONTRATANTE_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].OBRIGACOES_CONTRATANTE_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 15-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>15. GARANTIAS FÍSICAS - TÉCNICAS (Responsável: {{ dados[0].GARANTIAS_FISICAS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].GARANTIAS_FISICAS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].GARANTIAS_FISICAS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 16-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>16. GARATIAS FINANCEIRAS (SEGUROS, FIANÇAS, ETC) (Responsável: {{ dados[0].GARANTIAS_FINANCEIRAS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].GARANTIAS_FINANCEIRAS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].GARANTIAS_FINANCEIRAS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 17-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>17. SEGUROS (RESPONSABILIDADE CIVIL, TRABALHISTA, AMBIENTAL, VEÍCULOS, ETC) (Responsável: {{ dados[0].SEGUROS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].SEGUROS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].SEGUROS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 18-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>18. DANOS DIRETO, DANOS INDIRETOS, PREJUÍZOS, LUCRO CESSANTE, MULTA NÃO COMPENSATÓRIA (RESPONSABILIDADE CIVIL) (Responsável: {{ dados[0].DANOS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].DANOS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].DANOS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 19-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>19. SST, QUALIDADE (Responsável: {{ dados[0].SST_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].SST_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].SST_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 20-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>20. EXCLUSIVIDADE (Responsável: {{ dados[0].EXCLUSIVIDADE_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].EXCLUSIVIDADE_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].EXCLUSIVIDADE_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 21-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>21. CONDIÇÕES SUSPENSIVAS (Responsável: {{ dados[0].SUSPENSIVAS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].SUSPENSIVAS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].SUSPENSIVAS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 22-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>22. CASO FORTUITO - FORÇA MAIOR (Responsável: {{ dados[0].CASO_FORTUITO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].CASO_FORTUITO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].CASO_FORTUITO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 23 -->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>23. PENALIDADES, ATRASOS (Responsável: {{ dados[0].PENALIDADES_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].PENALIDADES_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].PENALIDADES_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 24-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>24. RESCISÃO (Responsável: {{ dados[0].RESCISAO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].RESCISAO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].RESCISAO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 25-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>25. DECLARAÇÃO DE CUMPRIMENTO (Responsável: {{ dados[0].CUMPRIMENTO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].CUMPRIMENTO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].CUMPRIMENTO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 26-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>26. ANEXOS AO CONTRATO (Responsável: {{ dados[0].ANEXOS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].ANEXOS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].ANEXOS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 27-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>27. CRONOGRAMA FÍSICO FINANCEIRO (Responsável: {{ dados[0].CRONOGRAMA_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].CRONOGRAMA_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].CRONOGRAMA_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 28-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>28. DESCRIÇÃO DO IMÓVEL (Responsável: {{ dados[0].DESCRICAO_IMOVEL_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].DESCRICAO_IMOVEL_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].DESCRICAO_IMOVEL_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 29-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>29. CONDIÇÃO DE ENTREGA DO IMÓVEL (Responsável: {{ dados[0].CONDICOES_IMOVEL_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].CONDICOES_IMOVEL_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].CONDICOES_IMOVEL_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 30-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>30. REGISTRO E ESCRITURA (Responsável: {{ dados[0].REGISTRO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].REGISTRO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].REGISTRO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 31-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>31. CLÁUSULA DE ARREPENDIMENTO (Responsável: {{ dados[0].ARREPENDIMENTO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].ARREPENDIMENTO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].ARREPENDIMENTO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 32-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>32. OUTRAS OBSERVAÇÕES (Responsável: {{ dados[0].OUTRAS_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].OUTRAS_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].OUTRAS_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ITEM 33-->
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong>33. FORO/CÂMARA DE CONCILIAÇÃO E ARBITRAGEM (Responsável: {{ dados[0].FORO_RESPONSAVEL }})</strong><br>
              <span v-html="dados[0].FORO_DESCRICAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 5px;">
              <strong style="font-size: 10px;">Observações:</strong><br>
              <span v-html="dados[0].FORO_OBSERVACAO" style="font-size: 10px;"></span>
            </td>
          </tr>
          <!-- ASSINATURAS -->
          <!-- <tr>
            <td style="border: 2px solid black; padding: 20px;">
              <table style="width: 100%; text-align: center; border: none; margin-top: 20px;">
                <tr>
                  <td style="border: none;">
                    ____________________________
                    <div>Departamento Comercial</div>
                  </td>
                  <td style="border: none;">
                    ____________________________
                    <div>Departamento Jurídico</div>
                  </td>
                  <td style="border: none;">
                    ____________________________
                    <div>Diretoria</div>
                  </td>
                </tr>
              </table>
            </td>
          </tr> -->
        </table>
        <!-- <p style="padding: 5px; font-size: 10px;">
          <strong>Observações:</strong> A versão final e atualizada deste Relatório de Acompanhamento após as assinaturas no contrato,
          deverá ser disponibilizada confidencialmente para os responsáveis (Ex.: Coordenador de Contratos, Coordenador de Departamento, Responsável do Planejamento, etc.).
        </p> -->
      </div>
    </ReportContainer>
  </div>
</template>

<script>
import ReportContainer from '@/components/reports/ReportContainer.vue'

export default {
  components: { ReportContainer },
  props: {
    dados: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      assinaturas: {
        columns: [
          {
            width: '33%',
            alignment: 'center',
            fontSize: 8,
            stack: [
              { text: '________________________________', margin: [0, 20, 0, 0] },
              { text: 'Departamento Comercial', margin: [0, 5, 0, 0] }
            ]
          },
          {
            width: '33%',
            alignment: 'center',
            fontSize: 8,
            stack: [
              { text: '________________________________', margin: [0, 20, 0, 0] },
              { text: 'Departamento Jurídico', margin: [0, 5, 0, 0] }
            ]
          },
          {
            width: '33%',
            alignment: 'center',
            fontSize: 8,
            stack: [
              { text: '________________________________', margin: [0, 20, 0, 0] },
              { text: 'Diretoria', margin: [0, 5, 0, 0] }
            ]
          }
        ],
        margin: [0, 20, 0, 0]
      },
      observacao: {
        text: 'Observações: A versão final e atualizada deste Relatório de Acompanhamento após as assinaturas no contrato, deverá ser disponibilizada confidencialmente para os responsáveis (Ex.: Coordenador de Contratos, Coordenador de Departamento, Responsável do Planejamento, etc.).',
        fontSize: 6,
        margin: [0, 20, 0, 0]
      }
    }
  }
}

</script>

<style scoped>
.relatorio-container {
  border: 2px solid #000;
  padding: 20px;
  margin: 20px auto;
  background-color: white;
  border-radius: 4px;
}
.relatorio-item {
  margin-bottom: 15px;
}

.relatorio-separador {
  border-top: 1px solid #aaa;
  margin: 15px 0;
}
* >>> td > span > table,
* >>> td > span > table td,
* >>> td > span > table tr {
  border: 1px solid
}
* >>> td > span > table td {
  padding: 5px;
}
* >>> td > span > h1 {
  font-size: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/reports/ReportJuridicoContrato.vue